function About() {
  return (
    <div className="mt-16 About">
      <section class="text-black body-font">
        <div class="container mx-auto flex px-5 py-8 items-center justify-center flex-col">
          <div class="text-center lg:w-2/3 w-full">
            <h1
              class="title-font sm:text-7xl text-4xl mb-4 font-medium  orange-text "
              style={{ fontFamily: "font1" }}
            >
              About
            </h1>

            <p class="mb-8 leading-relaxed text-left text-xs sm:text-xl">
              Ecoz are a collection of 1050 NFTs living fully on the block
              chain, painted with a pallet of 86 colors. There are 3 types of
              Ecoz, all dependent on each other to thrive. All genesis Ecoz
              produce $THRIVE, which can be used to breed Baby Ecoz. At the
              equilibrium point, Ecoz breed a certain amount of $THRIVE, when
              the species shifts from the equilibrium, the breeding cost shift
              as well. Breeding Baby Ecoz is fun and all, but this is only the
              beginning...
            </p>
            <div class="flex justify-center">
              <a
                class="underline uppercase flex align-middle justify-center items-center"
                href="https://docs.google.com/document/d/1eP9f3Ki5BrsHjMbic59ZgS0Llyxg0n9qWIEvyNzHJpI/edit#heading=h.z6ne0og04bp5"
                target="_blank"
                rel="noreferrer"
              >
                <h1 class="mx-2">Ecoz Whitepaper</h1>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
